import mixin from './mixin';

import SourceSet from './components/SourceSet.vue';
import ApiSourceSet from './components/ApiSourceSet.vue';

import Fuse from 'fuse.js';

const fuseOptions = {
    shouldSort: false,
    keys: ['Name', 'Title', 'IntroText'],
};

const topicOverviewApp = {
    mixins: [mixin],
    components: {
        SourceSet,
        ApiSourceSet,
    },
    data() {
        return {
            dataJson: null,
            searchText: '',
            itemsToShow: 15,
        };
    },
    computed: {
        filteredItems() {
            if (!this.dataJson) return [];
            if (!this.searchText) return this.dataJson.slice(0, this.itemsToShow);
            const fuse = new Fuse(this.dataJson, fuseOptions);
            let results = fuse.search(this.searchText);
            return results
                .map((result) => result.item)
                .sort((a, b) => a.Name.localeCompare(b.Name))
                .slice(0, this.itemsToShow);
        },
        hasMoreItems() {
            return !this.searchText && this.dataJson && this.itemsToShow < this.dataJson.length;
        },
    },
    methods: {
        loadMore() {
            this.itemsToShow += 15;
        },
    },
    created() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('q')) this.searchText = urlParams.get('q');

        this.changeSearchText = this.debounce(() => {
            const url = new URL(location);
            url.searchParams.set('q', this.searchText);
            if (!this.searchText) url.searchParams.delete('q');
            history.pushState({}, '', url);
        });
    },
    mounted() {
        if (this.$el.dataset.json) {
            this.dataJson = JSON.parse(this.$el.dataset.json);
        }
    },
};

export default topicOverviewApp;
